<template>
  <div class="monitoring-cabin-container">
    <v-track-search name="历史轨迹回放"></v-track-search>
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group>
          <el-button @click="getData" size="mini" type="primary" icon="el-icon-search">查询
          </el-button>
          <el-button @click="reset" size="mini" type="primary" icon="el-icon-refresh">重置</el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15">
        <div class="item">
          <span class="span">部门</span>
          <el-select size="mini" v-model="obj.select" placeholder="请选择部门">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="span">工种</span>
          <el-select size="mini" v-model="obj.select11" placeholder="请选择工种">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <div class="span">姓名</div>
          <el-input v-model="obj.txt" placeholder="请输入姓名" size="mini"></el-input>
        </div>
        <div class="item">
          <div class="span">工号</div>
          <el-input v-model="obj.txt11" placeholder="请输入工号" size="mini"></el-input>
        </div>
        <div class="item">
          <div class="span">识别卡</div>
          <el-input v-model="obj.txt11" placeholder="请输入识别卡" size="mini"></el-input>
        </div>
        <div class="item">
          <div class="span">起止时间</div>
          <el-date-picker size="mini" class="date-time" v-model="obj.dates"
                          type="datetimerange"
                          range-separator="到" start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
        </div>

      </div>
    </div>

    <div class="video-tracking-box mt-15">
      <div class="left">
        <div class="left-table">
          <div class="item">
            <span style="width:70px">工号</span><span style="width:100px;">姓名</span>
          </div>
          <div class="item tran-all" :class="personIndex==index?'active':''"
               v-for="(item,index) in list" :key="index"
               @click="selectPerson(index)">
            <span style="width:70px">{{item.user.id}}</span><span style="width:100px;">{{item.user.name}}</span></div>
        </div>
        <div class="detail">
          <div class="item tran-all" :class="pathIndex===index?'active':''"
               v-for="(item,index) in list[personIndex].paths" :key="index"
               @click="selectPath(index)">
            {{list[personIndex].user.name}}{{item.millisecond | formatDateTime}}{{item.type === 'in' ? '进入' : '离开'}}{{item.station_name}}
          </div>
        </div>
      </div>
      <div class="right">
        <!--<v-ship-map-drawline ref="shipmap"-->
        <!--:containerHeight="500" :shipMapData="dataToMap"-->
        <!--:points="points" :ship_img="ship_img">-->
        <!--</v-ship-map-drawline>-->
        <v-ship-map-drawline ref="shipmap" :ship_img="ship_img"
                             :containerHeight="500">
        </v-ship-map-drawline>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  import ShipMapDrawline from '../../components/ship-map-drawline-tracked-mock.vue';
  //import ShipMapDrawlineMock from '../../components/ship-map-drawline-mock-20200528.vue';
  import ShipMapDrawlineMock from '../../components/ship-map-drawline.vue';
  import {mock} from '../../common/js/mock2.js';
  let timeoutFunction, intervalFunction;
  export default {
    data() {
      return {
        ship_img: {
          url: '',
          width: 0,
          height: 0
        },
        dataToMap: {},
        dataFromMap: {},
        obj: {
          txt: "",
          txt11: "",
          select: "",
          select11: "",
          date: "",
          datas: "",
          dateTime: "",
          number: ""
        },
        list: [],
        personIndex: 0,
        pathIndex: 0,
        lines: [],
        currentMillisecond: 0
      };
    },

    computed: {},

    created() {
      this.getData();
      this.ship_img.width = 5000;
      this.ship_img.height = 1815;
      this.ship_img.url = '1111';
    },

    mounted(){
    },

    methods: {
      getLines(){
        clearTimeout(timeoutFunction);
        timeoutFunction = null;
        let paths = this.list[this.personIndex].paths;
        let lines = [];
        let i = 0;
        while (i < paths.length - 1) {
          if (paths[i].station_id === paths[i + 1].station_id) {  //同基站（停留）
            let tmp = {
              x1: paths[i].station_points[0].x,
              y1: paths[i].station_points[0].y,
              x2: paths[i].station_points[0].x,
              y2: paths[i].station_points[0].y,
              pathIndex: i,
              station_id: paths[i].station_id,
              duration: paths[i + 1].millisecond - paths[i].millisecond,
              delay: paths[i].millisecond - paths[0].millisecond,
              type: 'in'
            };
            lines = [...lines, tmp];
          } else {
            if (paths[i].passage_id === paths[i + 1].passage_id) {  //同过道
              let thisPoints = [...paths[i].station_points];
              let nextPoints = [...paths[i + 1].station_points].reverse();
              let tmp = [...thisPoints, ...nextPoints];
              let tStep = (paths[i + 1].millisecond - paths[i].millisecond) / (tmp.length - 1);
              let temp = [];
              for (let k = 0; k < tmp.length - 1; k++) {
                let tt = {
                  x1: tmp[k].x,
                  y1: tmp[k].y,
                  x2: tmp[k + 1].x,
                  y2: tmp[k + 1].y,
                  pathIndex: i,
                  millisecond: paths[i].millisecond + tStep * k,
                  duration: tStep,
                  delay: paths[i].millisecond - paths[0].millisecond + tStep * k
                };
                temp.push(tt);
              }
              temp[temp.length - 1].type = 'in';
              lines = [...lines, ...temp];
            } else if (paths[i].deck_id === paths[i + 1].deck_id) {  //同甲板
              let togglePassage = this.getPassageConnectLine(paths[i].deck_id, paths[i].passage_id, paths[i + 1].passage_id);
              let thisPoints = [...paths[i].station_points];
              let nextPoints = [...paths[i + 1].station_points].reverse();
              let tmp = [...thisPoints, togglePassage[0].point, togglePassage[1].point, ...nextPoints];
              let tStep = (paths[i + 1].millisecond - paths[i].millisecond) / (tmp.length - 1);
              let temp = [];
              for (let k = 0; k < tmp.length - 1; k++) {
                let tt = {
                  x1: tmp[k].x,
                  y1: tmp[k].y,
                  x2: tmp[k + 1].x,
                  y2: tmp[k + 1].y,
                  pathIndex: i,
                  millisecond: paths[i].millisecond + tStep * k,
                  duration: tStep,
                  delay: paths[i].millisecond - paths[0].millisecond + tStep * k
                };
                temp.push(tt);
              }
              temp[temp.length - 1].type = 'in';
              lines = [...lines, ...temp];
            } else if (paths[i].deck_id !== paths[i + 1].deck_id) {  //不同甲板
              let thisStationPoints = [...paths[i].station_points];
              let nextStationPoints = [...paths[i + 1].station_points].reverse();
              console.log(thisStationPoints);
              console.log(nextStationPoints);
              let a = this.getPassageFromStationToStair(paths, i);
              let passage1_id = a[0];
              let stair1_point = a[1];
              let passage2_id = a[2];
              let stair2_point = a[3];
              console.log(passage1_id, stair1_point);
              console.log(passage2_id, stair2_point);
              let stationToStairPoints = [];
              if (paths[i].passage_id === passage1_id) {  //基站到楼梯
                console.log(`基站${paths[i].station_id}到基站${paths[i + 1].station_id}-基站到楼梯-同过道`);
                stationToStairPoints = [...thisStationPoints, stair1_point];
                console.log(stationToStairPoints);
              } else {
                console.log(`基站${paths[i].station_id}到基站${paths[i + 1].station_id}-基站到楼梯-不同过道`);
                let passageConnectLine = this.getPassageConnectLine(paths[i].deck_id, paths[i].passage_id, passage1_id);
                console.log(passageConnectLine);
                stationToStairPoints = [...thisStationPoints, passageConnectLine[0].point, passageConnectLine[1].point, stair1_point];
                console.log(stationToStairPoints);
              }
              let stairToStationPoints = [];
              if (passage2_id === paths[i + 1].passage_id) {  //楼梯到下一个基站
                console.log(`基站${paths[i].station_id}到基站${paths[i + 1].station_id}-楼梯到基站-同过道`);
                stairToStationPoints = [stair2_point, ...nextStationPoints];
                console.error(stairToStationPoints);
              } else {
                console.log(`基站${paths[i].station_id}到基站${paths[i + 1].station_id}-楼梯到基站-不同过道`);
                let passageConnectLine = this.getPassageConnectLine(paths[i + 1].deck_id, passage2_id, paths[i + 1].passage_id);
                console.error(passageConnectLine)
                stairToStationPoints = [stair2_point, passageConnectLine[0].point, passageConnectLine[1].point, ...nextStationPoints];
                //stairToStationPoints[0].type = 'toggle_deck';
                console.error(stairToStationPoints);
              }
              console.error(stationToStairPoints)
              //stationToStairPoints[stationToStairPoints.length - 1].type = 'toggle_deck';
              console.error(stationToStairPoints)
              let tmp = [...stationToStairPoints, ...stairToStationPoints];
              console.error(tmp);
              let tStep = (paths[i + 1].millisecond - paths[i].millisecond) / (tmp.length - 1);
              let temp = [];
              for (let k = 0; k < tmp.length - 1; k++) {
                let tt = {
                  x1: tmp[k].x,
                  y1: tmp[k].y,
                  x2: tmp[k + 1].x,
                  y2: tmp[k + 1].y,
                  pathIndex: i,
                  millisecond: paths[i].millisecond + tStep * k,
                  duration: tStep,
                  delay: paths[i].millisecond - paths[0].millisecond + tStep * k,
                  type: tmp[k].type
                };
                temp.push(tt);
              }
              temp[temp.length - 1].type = 'in';
              lines = [...lines, ...temp];
            }
          }
          i++;
        }
        setTimeout(() => {
          console.log(lines);
          this.$refs.shipmap.startAnimation(lines);
          this.getPathIndex();
        }, 10);
      },

      getPassageFromStationToStair(paths, i){
        let stair = this.getStairByTwoDeckId(paths[i].deck_id, paths[i + 1].deck_id, paths, i);
        console.log(`基站${paths[i].station_id}到基站${paths[i + 1].station_id}使用${stair.id}楼梯`);
        let passage1_id = 0;
        let passage1_point = null;
        let passage2_id = 0;
        let passage2_point = null;
        if (paths[i].deck_id < paths[i + 1].deck_id) {
          passage1_id = stair.passage1.id;
          passage1_point = stair.point1;
          passage2_id = stair.passage2.id;
          passage2_point = stair.point2;
          //passage1_point.type = 'toggle_deck';
        } else {
          passage1_id = stair.passage2.id;
          passage1_point = stair.point2;
          passage2_id = stair.passage1.id;
          passage2_point = stair.point1;
          //passage1_point.type = 'toggle_deck';
        }
        //passage1_point.type = 'toggle_deck';
        let p1 = Object.assign({}, passage1_point);
        p1.type = 'toggle_deck';
        console.log(passage1_id, p1, passage2_id, passage2_point);
        return [passage1_id, p1, passage2_id, passage2_point];
      },

      getStairByTwoDeckId(deck1_id, deck2_id, paths, i){
        let allStair = mock.stair;
        let d1 = deck1_id < deck2_id ? deck1_id : deck2_id;
        let stairs = [];
        for (let i = 0; i < allStair.length; i++) {
          if (allStair[i].deck1.id === d1 && allStair[i].deck2.id) {
            stairs.push(allStair[i]);
          }
        }
        if (stairs.length === 0) {
          this.stop();
          tool.message('无可通行楼梯', 'warning');
          return;
        }
        let stair = null;
        for (let k = 0; k < stairs.length; k++) {
          if (paths[i].deck_id < paths[i + 1].deck_id) {
            if (paths[i].passage_id === stairs[k].passage1.id) {
              stair = stairs[k];
              break;
            }
          } else {
            if (paths[i].passage_id === stairs[k].passage2.id) {
              stair = stairs[k];
              break;
            }
          }
        }
        if (stair === null) {
          stair = stairs[0];
        }
        console.log(stair);
        return stair;
      },

      getPathIndex(){
        clearInterval(intervalFunction);
        let paths = this.list[this.personIndex].paths;
        this.currentMillisecond = paths[0].millisecond;
        let lastMillisecond = paths[paths.length - 1].millisecond;
        console.log(this.currentMillisecond, lastMillisecond);
        intervalFunction = setInterval(() => {
          if (this.currentMillisecond <= lastMillisecond) {
            this.currentMillisecond = this.currentMillisecond + 100;
            //console.log(this.currentMillisecond);
            for (let k = paths.length - 1; k > -1; k--) {
              if (paths[k].millisecond <= this.currentMillisecond) {
                //console.log(k);
                this.pathIndex = k;
                break;
              }
            }
          } else {
            clearInterval(intervalFunction);
            intervalFunction = null;
          }
        }, 100);
      },

      getStationById(id){
        let stations = mock.station;
        let info = {};
        for (let i = 0; i < stations.length; i++) {
          if (id === stations[i].id) {
            info = stations[i];
          }
        }
        return info;
      },

      getPassageConnectLine(deckId, passage1Id, passage2Id){
        let deckPassageConnect = [];
        for (let i = 0; i < mock.deck_connect_passage.length; i++) {
          if (deckId === mock.deck_connect_passage[i].deck_id) {
            deckPassageConnect = mock.deck_connect_passage[i].connect;
            break;
          }
        }
        let passage1_id = passage2Id > passage1Id ? passage1Id : passage2Id;
        let passage2_id = passage1Id > passage2Id ? passage1Id : passage2Id;
        let connectLine = {};
        for (let i = 0; i < deckPassageConnect.length; i++) {
          if (passage1_id === deckPassageConnect[i].passage1_id &&
              passage2_id === deckPassageConnect[i].passage2_id) {
            connectLine = deckPassageConnect[i];
          }
        }
        let passage1 = {};
        let passage2 = {};
        for (let i = 0; i < mock.passage.length; i++) {
          if (connectLine.passage1_id === mock.passage[i].id) {
            passage1 = mock.passage[i];
          }
          if (connectLine.passage2_id === mock.passage[i].id) {
            passage2 = mock.passage[i];
          }
        }
        if (connectLine.passage1_point === 'right_bottom') {
          passage1.point = passage1.right_bottom_point;
        } else {
          passage1.point = passage1.left_up_point;
        }
        // console.error(passage1, passage2);
        if (connectLine.passage2_point === 'right_bottom') {
          passage2.point = passage2.right_bottom_point;
        } else {
          passage2.point = passage2.left_up_point;
        }
        // console.error(passage1, passage2);
        if (passage2Id > passage1Id) {
          return [passage1, passage2];
        } else {
          return [passage2, passage1];
        }
      },

      selectPerson(index){
        this.personIndex = index;
        this.pathIndex = 0;
        this.lines = [];
        this.$refs.shipmap.clearLines();
        this.getLines();
      },

      selectPath(index){
        this.pathIndex = index;
        this.points = [];
        this.$refs.shipmap.clearLines();
        this.getLines();
      },

      getData() {
        this.list = mock.temp_path;
      },

      reset() {
        this.getData();
      },

      handleCurrentChange(val) {
        this.getAllPoints(val);
      },

    },

    beforeRouteLeave(to, form, next){
      clearTimeout(timeoutFunction);
      timeoutFunction = null;
      next();
    },

    components: {
      'v-ship-map-drawline': ShipMapDrawline,
      'v-ship-map-drawline-mock': ShipMapDrawlineMock
    },

    filters: {
      formatDateTime: (a) => {
        return a ? tool.formatDateTime(a) : ''
      }
    }
  };
</script>

<style lang="less" rel="stylesheet/less">
  .monitoring-cabin-container {
    width: 100%;
    height: auto;
    display: flex;
    align-items: stretch;
    padding: 15px;
    flex-direction: column;
    .video-tracking-box {
      width: 100%;
      min-height: 500px;
      height: auto;
      display: flex;
      .left {
        width: 200px;
        .left-table {
          height: 300px;
          overflow-y: auto;
          background: white;
          .item {
            width: 100%;
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #eee;
            color: #333;
            cursor: pointer;
            &.active, &:hover {
              background: #eee;
            }
            span {
              display: inline-block;
              text-align: center;
              font-size: 12px;
            }
          }
        }
        .detail {
          background: white;
          margin-top: 10px;
          height: 225px;
          overflow-y: auto;
          .item {
            padding: 5px 10px;
            font-size: 12px;
            line-height: 20px;
            cursor: pointer;
            &.active, &:hover {
              background: #eee;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
      .right {
        width: 0;
        height: 535px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(230, 230, 230, 1);
        padding: 15px;
        flex: 1;
        margin-left: 15px;
      }
    }
  }
</style>

